import $ from 'jquery'
import Cookies from 'js-cookie'

const darkMode = new BroadcastChannel('darkMode')

const enableDarkMode = () => {
  $('body').addClass('dark-mode')
  Cookies.set('darkMode', 'on', { expires: 365 })
}

const disableDarkMode = () => {
  $('body').removeClass('dark-mode')
  Cookies.set('darkMode', 'off', { expires: 365 })
}

$('.theme-mode').on('click', function () {
  const isDark = $('body').hasClass('dark-mode')

  if (!isDark) {
    enableDarkMode()
    darkMode.postMessage('enableDarkMode')
  } else {
    disableDarkMode()
    darkMode.postMessage('disableDarkMode')
  }
})

darkMode.addEventListener('message', (event) => {
  if (event.data === 'enableDarkMode') {
    enableDarkMode()
  }

  if (event.data === 'disableDarkMode') {
    disableDarkMode()
  }
})
